export default "__VITE_ASSET__CaVsODen__"